import { gql } from '@apollo/client';

// IB-1899: periods owed by the current organisation, soonest due first
export const MY_REPORTING_PERIODS = gql`
  query myReportingPeriods($filter: MyReportingPeriodsFilter) {
    periods: myReportingPeriods(filter: $filter) {
      id
      requirementId
      requirementName
      requiringOrganisationName
      itemType
      itemId
      itemName
      periodNumber
      label
      periodStart
      periodEnd
      opensOn
      dueOn
      status
      statusLabel
      action
      recordId
      submissionsPerPeriod
    }
  }
`;
